import { useState } from 'react';
import { useForm } from 'react-hook-form';

type FormValues = {
  typeOfLaddbox: string;
  firstName: string;
  lastName: string;
  street: string;
  zipCode: string;
  city: string;
  email: string;
  cemail: string;
  phone: string;
  confirmedByBrf: string;
};

const ContactForm = () => {
  const [error, setError] = useState<string | undefined>();
  const [success, setSuccess] = useState<string | undefined>();
  const [loading, setLoading] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [street, setStreet] = useState('');
  const [zipCode, setZipCode] = useState('');
  const [city, setCity] = useState('');
  const [email, setEmail] = useState('');
  const [cemail, setCemail] = useState('');
  const [phone, setPhone] = useState('');

  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm<FormValues>();

  const handleError = (error: unknown) => {
    console.log(error);
    setError(
      'Något gick fel när vi skulle ta emot din beställning, försök igen senare'
    );
  };

  const handleSuccess = () => {
    setSuccess(
      'Tack för din beställning, vi hör av oss till dig så snart vi kan!'
    );
  };

  const handleChange = () => {
    //updates state
  };

  const onSubmit = async (values: FormValues) => {
    setLoading(true);
    try {
      // send mail
      await fetch('https://kia-nodemailer.vercel.app/api/booking', {
        method: 'POST',
        headers: {
          Accept: 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ values }),
      }).then((res) => {
        if (res.status === 200) {
          handleSuccess();
        } else {
          handleError(res);
        }
      });
    } catch (error) {
      handleError(error);
    }
    setLoading(false);
  };

  return (
    <div className="kia_boka_laddbox--wrapper">
      <h1>Beställning DEFA Power laddbox</h1>
      <div className="kia_boka_laddbox">
        {success && (
          <div className="kia_boka_laddbox--success">
            <h4 className="py-4 px-1 px-4-d">{success}</h4>
          </div>
        )}
        {loading && (
          <div className="kia_boka_laddbox--loading">
            <h4 className="py-4 px-1 px-4-d">Skickar din beställning...</h4>
          </div>
        )}
        <form onChange={() => handleChange()} onSubmit={handleSubmit(onSubmit)}>
          <h4 className="pl-17 grey2">Val av laddbox</h4>
          <div className="gg-2 relative">
            <label>
              <input
                {...register('typeOfLaddbox', {
                  required: {
                    value: true,
                    message: 'Du måste välja en laddbox',
                  },
                })}
                type="radio"
                id="typeOfLaddbox"
                name="typeOfLaddbox"
                value="Laddbox samt installation med Grön Teknik-avdrag.
                  Pris från 8 480 kr"
              />
              <p
                dangerouslySetInnerHTML={{
                  __html:
                    'Laddbox samt installation med Grön Teknik-avdrag.<br>Pris från 8 480 kr',
                }}
              ></p>
            </label>
            <label>
              <input
                {...register('typeOfLaddbox', {
                  required: {
                    value: true,
                    message: 'Du måste välja en laddbox',
                  },
                })}
                type="radio"
                id="typeOfLaddbox"
                name="typeOfLaddbox"
                value="Laddbox med lastbalansering samt installation med Grön Teknik-avdrag.
                  Pris från 9 820 kr"
              />
              <p
                dangerouslySetInnerHTML={{
                  __html:
                    'Laddbox med lastbalansering samt installation med Grön Teknik-avdrag. <br>Pris från 9 820 kr',
                }}
              ></p>
            </label>
            {errors.typeOfLaddbox && (
              <span>{errors.typeOfLaddbox.message}</span>
            )}
          </div>
          <br />
          <div className="input_wrapper">
            <div className="relative">
              <input
                type="text"
                className={firstName ? 'input-filled' : ''}
                {...register('firstName', {
                  required: {
                    value: true,
                    message: 'Du måste ange ditt förnamn',
                  },
                })}
                onChange={(e) => setFirstName(e.target.value)}
              />
              <label htmlFor="firstName">Förnamn *</label>
            </div>
            {errors.firstName && <span>{errors.firstName.message}</span>}
          </div>
          <div className="input_wrapper">
            <div>
              <input
                type="text"
                className={lastName ? 'input-filled' : ''}
                {...register('lastName', {
                  required: {
                    value: true,
                    message: 'Du måste ange ditt förnamn',
                  },
                })}
                onChange={(e) => setLastName(e.target.value)}
              />
              <label htmlFor="lastName">Efternamn *</label>
            </div>
            {errors.lastName && <span>{errors.lastName.message}</span>}
          </div>
          <div className="input_wrapper">
            <div className="relative">
              <input
                type="text"
                className={street ? 'input-filled' : ''}
                {...register('street', {
                  required: {
                    value: true,
                    message: 'Du måste ange adress',
                  },
                })}
                onChange={(e) => setStreet(e.target.value)}
              />
              <label htmlFor="street">Adress *</label>
            </div>
            {errors.street && <span>{errors.street.message}</span>}
          </div>
          <div className="gg-2">
            <div className="input_wrapper">
              <div className="relative">
                <input
                  type="text"
                  className={zipCode ? 'input-filled' : ''}
                  {...register('zipCode', {
                    required: {
                      value: true,
                      message: 'Du måste ange postnummer',
                    },
                  })}
                  onChange={(e) => setZipCode(e.target.value)}
                />
                <label htmlFor="zipCode">Postnummer*</label>
              </div>
              {errors.zipCode && <span>{errors.zipCode.message}</span>}
            </div>
            <div className="input_wrapper">
              <div className="relative">
                <input
                  type="text"
                  className={city ? 'input-filled' : ''}
                  {...register('city', {
                    required: {
                      value: true,
                      message: 'Du måste ange stad/ort',
                    },
                  })}
                  onChange={(e) => setCity(e.target.value)}
                />
                <label htmlFor="city">stad/ort*</label>
              </div>
              {errors.city && <span>{errors.city.message}</span>}
            </div>
          </div>
          <div className="input_wrapper">
            <div className="relative">
              <input
                type="email"
                className={email ? 'input-filled' : ''}
                {...register('email', {
                  required: {
                    value: true,
                    message: 'Du måste ange en e-postadress',
                  },
                  pattern: {
                    // eslint-disable-next-line no-useless-escape
                    value: new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g),
                    message: 'Du måste ange en giltig e-postadress',
                  },
                })}
                onChange={(e) => setEmail(e.target.value)}
              />
              <label htmlFor="email">E-POST *</label>
            </div>
            {errors.email && <span>{errors.email.message}</span>}
          </div>
          <div className="input_wrapper">
            <div className="relative">
              <input
                type="email"
                className={cemail ? 'input-filled' : ''}
                {...register('cemail', {
                  validate: (value) => {
                    return (
                      value === getValues('email') ||
                      'E-postadresserna måste matcha'
                    );
                  },
                })}
                onChange={(e) => setCemail(e.target.value)}
              />
              <label htmlFor="cemail">Bekräfta e-postadress*</label>
            </div>
            {errors.cemail && <span>{errors.cemail.message}</span>}
          </div>
          <div className="input_wrapper">
            <div className="relative">
              <input
                type="tel"
                className={phone ? 'input-filled' : ''}
                {...register('phone', {
                  required: {
                    value: true,
                    message: 'Du måste ange ett telefonnummer',
                  },
                  pattern: {
                    value: new RegExp(/^[\d-+ ]+$/g),
                    message: 'Du måste ange ett giltigt telefonnummer',
                  },
                })}
                onChange={(e) => setPhone(e.target.value)}
              />
              <label htmlFor="phone">Telefonnr*</label>
            </div>
            {errors.phone && <span>{errors.phone.message}</span>}
          </div>
          <h4
            className="grey2"
            dangerouslySetInnerHTML={{
              __html:
                ' Har installationen/produkten godkänts av fastighetsägaren/<wbr>bostadsrättsföreningen?',
            }}
          ></h4>
          <div className="d-flex gap-2 relative">
            <label>
              <input
                {...register('confirmedByBrf', {
                  required: {
                    value: true,
                    message: 'Du måste svara på ovanstående fråga',
                  },
                })}
                type="radio"
                id="confirmedByBrf"
                name="confirmedByBrf"
                value="Ja"
              />
              <p>Ja</p>
            </label>
            <label>
              <input
                {...register('confirmedByBrf', {
                  required: {
                    value: true,
                    message: 'Du måste svara på ovanstående fråga',
                  },
                })}
                type="radio"
                id="confirmedByBrf"
                name="confirmedByBrf"
                value="Nej"
              />
              <p>Nej</p>
            </label>
            <label>
              <input
                {...register('confirmedByBrf', {
                  required: {
                    value: true,
                    message: 'Du måste svara på ovanstående fråga',
                  },
                })}
                type="radio"
                id="confirmedByBrf"
                name="confirmedByBrf"
                value="Inte relevant"
              />
              <p>Inte relevant</p>
            </label>
          </div>
          {errors.confirmedByBrf && (
            <span>{errors.confirmedByBrf.message}</span>
          )}
          <div className="d-flex space-between">
            <p>När du skickat din beställning hör vi av oss.</p>
            <input className="button-primary" type="submit" value="Skicka  >" />
          </div>
          {error && <span>{error}</span>}
        </form>
      </div>
      <div className="terms">
        <p className="grey2">
          Jag samtycker till att Kia Sverige AB behandlar mina personuppgifter
          och delar dem med vald leverantör och installationspartner samt att
          installationspartnern kontaktar mig via telefon e-post eller SMS
          angående min beställning.
        </p>
        <a
          href="https://www.kia.com/se/integritetspolicy/"
          target="_blank"
          dangerouslySetInnerHTML={{ __html: '> Integritetspolicy' }}
          rel="noreferrer"
        ></a>
      </div>
    </div>
  );
};

export default ContactForm;
